import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '../../../../shared/components/Notistack/Notistack';
import { ILenderListItem } from '../shared/LenderControlsHeader';

const path = '/lender-service/lenders/lenderrank';

export const requestUpdateLenderRank = (lenderRank: ILenderListItem) => {
  return mutate(path, async() => {
    try {
      await axios.put(path, [
        {
          id: lenderRank.id,
          rank: lenderRank.rank,
          subRank: lenderRank.subRank,
        },
      ]);
      Notistack.successMessage('Lender Rank - Updated Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
